import { Box } from "@mui/material";
import { FormikValues, useFormikContext } from "formik";
import React, { useEffect } from "react";

import { useAppDispatch } from "../../../../redux/store";
import { setLoadingAction } from "../../../../redux/utils/actions";
import { logger } from "../../../../utils/logger";
import patientService from "../../../../services/patient";
import AdmissionDetails from "./Steps/AdmissionStepZero";
import AdmissionStepOne from "./Steps/AdmissionStepOne";
import SupportiveDocuments from "./Steps/AdmissionStepFour";
import ReferralRemarkAndNewDocuments from "./Steps/ReferralAdmissionStepFive";

const AddReReferralForm = ({
  steps,
  selectedPatientId,
}: {
  steps: number;
  selectedPatientId: string;
}) => {
  const { values, setFieldValue, setValues } = useFormikContext<FormikValues>();

  const dispatch = useAppDispatch();

  const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === "role" && values?.town) {
      setFieldValue("town", null);
    }
    setFieldValue(e.target.name, e.target.value, true);
  };

  useEffect(() => {
    const getData = async () => {
      try {
        if (selectedPatientId) {
          dispatch(setLoadingAction(true));
          const res = await patientService.getById(selectedPatientId);
          const { data } = res?.data;
          dispatch(setLoadingAction(false));
          const [year, month, day] = res?.data?.data?.age?.split("-");
          const formValues = {
            ...data,
            year,
            month,
            day,
            isLowerIncomeBeneficiary: `${data.isLowerIncomeBeneficiary}`,
            incomeCertificate:
              data?.incomeCertificate !== ""
                ? [
                    {
                      label: "Income Certificate",
                      path: data.incomeCertificate,
                    },
                  ]
                : "",
          };
          setValues({ ...values, ...formValues });
        }
      } catch (error: any) {
        dispatch(setLoadingAction(false));
        logger.error(error);
      }
    };
    if (selectedPatientId) {
      getData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, selectedPatientId, setValues]);

  return (
    <div>
      <Box>
        {steps === 0 && <AdmissionDetails />}
        {steps === 1 && <AdmissionStepOne />}
        {steps === 2 && <SupportiveDocuments />}
        {steps === 3 && <ReferralRemarkAndNewDocuments />}
      </Box>
    </div>
  );
};

export default AddReReferralForm;
